import { type FC } from "react";
import { cn } from "../../lib/utils";

interface RadioDotProps {
  /** Whether this option is currently selected. */
  selected: boolean;
  /** Extra classes for layout tweaks (e.g. alignment). */
  className?: string;
}

/**
 * Standardized single-select (radio) indicator used across all option/
 * assessment screens. Keeping the markup in one place guarantees the radio
 * looks and behaves identically on every screen and device (fixed size,
 * border, inner dot and transition) instead of each page rolling its own.
 */
export const RadioDot: FC<RadioDotProps> = ({ selected, className }) => (
  <span
    role="radio"
    aria-checked={selected}
    className={cn(
      "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors",
      selected ? "border-primary bg-primary" : "border-muted-foreground",
      className,
    )}
  >
    <span
      className={cn(
        "h-2 w-2 rounded-full bg-primary-foreground transition-opacity",
        selected ? "opacity-100" : "opacity-0",
      )}
    />
  </span>
);

export default RadioDot;
